import React, { useEffect } from 'react';

/**
 * Tiroir de gestion — fidèle au prototype (`prototype-cta/index.html` #drawer).
 * Le cockpit reste visible/actif derrière, assombri par le backdrop.
 * Ouvert depuis le rail (items « Gestion » + bas), fermé par le backdrop,
 * le bouton « Fermer » ou la touche Échap.
 */

interface Props {
  title: string;
  eyebrow?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const CockpitDrawer: React.FC<Props> = ({ title, eyebrow = 'Gestion — hors flux opérationnel', onClose, children }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} aria-hidden="true" />
      <section className="drawer" role="dialog" aria-modal="false" aria-label={title}>
        <div className="drawer__head">
          <div>
            <p className="drawer__eyebrow">{eyebrow}</p>
            <h2>{title}</h2>
          </div>
          <button className="drawer__close" type="button" onClick={onClose}>
            Fermer <kbd>Échap</kbd>
          </button>
        </div>
        <div className="drawer__body scroll">{children}</div>
      </section>
    </>
  );
};

export default CockpitDrawer;
